import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields } from '~/utils/strapiComponents/addStrapiData';

export const useStoreModalCompoints = defineStore('modalCompoints', {
  state: () => ({
    locale: 'en',
    compointsBalanceTitle: 'balance',
    compointsInputTitle: 'input',
    currencySelectTitle: 'currenct',
    successMessage: 'success',
    noticeText: 'notice',
    exchangeRateTitle: '',
    title: '',
    unavailableTitle: '',
    unavailableSubtitle: '',
    errorDivisibleNumber: '',
    insufficientBalance: '',
    compointsBalanceInfo: '',
    errorEmptyInputCompoints: '',
    compointsPlaceholder: '',
    compointsResult: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadCompointsModal() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('compoints-modal')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
